import React from 'react'
import './Topbar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
library.add(fas)


const Topbar = () => {
  return (
    <div class="topbar d-flex align-items-center">
         <div class="container-fluid container-xl position-relative d-flex align-items-center">
            <div class="top-left d-flex align-items-center me-auto">
                <ul>
                    <li><a href='/product-category/vlsi-online-courses/'>Online</a></li>
                    <li><a href='/courses'>Courses</a></li>
                    <li><a href='/vlsi-internship/'>Internship</a></li>
                    <li><a href='/product-category/vlsi-courses-for-freshers/'>job oriented courses</a></li>
                    <li><a href='/placements'>Placements</a></li>
                    <li><a href='/register-now/' class="lastchild">Admission</a></li>
                </ul>
            </div>
            <div class="top-right">
            <ul class="top_bar_info clearfix">

                    <li><FontAwesomeIcon icon="fa-solid fa-envelope" /><a href="mailto:info@takshila-vlsi.com">info@takshila-vlsi.com</a></li>
                    <li><FontAwesomeIcon icon="fa-solid fa-phone" /><a href="tel:+919742972744">+91 - 97429 72744</a></li>
					<li><FontAwesomeIcon icon="fa-solid fa-location-dot" /><a href="/best-vlsi-institute-in-bengaluru/" class="lastchild">Bengaluru</a> <a href="/best-vlsi-institute-in-hyderabad/" class="lastchild">Hyderabad</a> <a href="/best-vlsi-institute-in-chennai/">Chennai</a></li>
					
			</ul>
            </div>
         </div>
        

    </div>
  )
}

export default Topbar